module.exports = __webpack_public_path__ + "img/reward.f49685ba.svg";